import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";
import ContactPage from "./pages/ContactPage";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import MentionsLegales from "./pages/MentionsLegales";
import Rgpd from "./pages/Rgpd";
import Temoignages from "./pages/Temoignages";
import InstagramLinks from "./pages/InstagramLinks";
import PourquoiConsulter from "./pages/PourquoiConsulter";

// L'Hypnose
import HypnoseLanding from "./pages/hypnose/HypnoseLanding";
import Ericksonienne from "./pages/hypnose/Ericksonienne";
import Spirituelle from "./pages/hypnose/Spirituelle";
import Regressive from "./pages/hypnose/Regressive";
import HypnoseFAQ from "./pages/hypnose/HypnoseFAQ";

// Votre séance
import VotreSeanceLanding from "./pages/votre-seance/VotreSeanceLanding";
import Deroulement from "./pages/votre-seance/Deroulement";
import EnLigne from "./pages/votre-seance/EnLigne";
import CabinetPantin from "./pages/votre-seance/CabinetPantin";
import Tarifs from "./pages/votre-seance/Tarifs";
import APropos from "./pages/votre-seance/APropos";

import { AuthProvider } from "./lib/auth";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Toaster position="top-center" richColors closeButton />
          <Routes>
            {/* Page Link-in-bio Instagram — sans header/footer global */}
            <Route path="/instagram" element={<InstagramLinks />} />

            {/* Toutes les autres routes dans le Layout standard */}
            <Route
              path="/*"
              element={
                <Layout>
                  <Routes>
                    <Route path="/" element={<Home />} />

                    {/* L'Hypnose */}
                    <Route path="/hypnose" element={<HypnoseLanding />} />
                    <Route path="/hypnose/ericksonienne" element={<Ericksonienne />} />
                    <Route path="/hypnose/spirituelle" element={<Spirituelle />} />
                    <Route path="/hypnose/regressive" element={<Regressive />} />
                    <Route path="/hypnose/questions-frequentes" element={<HypnoseFAQ />} />

                    {/* Pourquoi consulter */}
                    <Route path="/pourquoi-consulter" element={<PourquoiConsulter />} />

                    {/* Votre séance */}
                    <Route path="/votre-seance" element={<VotreSeanceLanding />} />
                    <Route path="/votre-seance/deroulement" element={<Deroulement />} />
                    <Route path="/votre-seance/en-ligne" element={<EnLigne />} />
                    <Route path="/votre-seance/cabinet-pantin" element={<CabinetPantin />} />
                    <Route path="/votre-seance/tarifs" element={<Tarifs />} />
                    <Route path="/votre-seance/a-propos" element={<APropos />} />
                    <Route path="/votre-seance/temoignages" element={<Temoignages />} />

                    {/* Réserver (page de conversion) */}
                    <Route path="/reserver" element={<Contact />} />

                    {/* Contact (page dédiée à la prise de contact) */}
                    <Route path="/contact" element={<ContactPage />} />

                    {/* Blog */}
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/blog/:slug" element={<BlogPost />} />

                    {/* Redirections des anciennes URL (SEO friendly côté client) */}
                    <Route path="/qui-suis-je" element={<Navigate to="/votre-seance/a-propos" replace />} />
                    <Route path="/temoignages" element={<Navigate to="/votre-seance/temoignages" replace />} />
                    <Route path="/accompagnement" element={<Navigate to="/hypnose" replace />} />

                    {/* Admin & légal */}
                    <Route path="/login" element={<Login />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="/mentions-legales" element={<MentionsLegales />} />
                    <Route path="/politique-de-confidentialite" element={<Rgpd />} />
                    <Route path="/rgpd" element={<Navigate to="/politique-de-confidentialite" replace />} />

                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </Layout>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

function NotFound() {
  return (
    <section className="pt-40 pb-32 text-center" data-testid="not-found">
      <h1 className="text-5xl font-serif text-sand-900">404</h1>
      <p className="mt-4 text-sand-600">Cette page n'existe pas.</p>
      <a href="/" className="btn-outline mt-8 inline-flex">Retour à l'accueil</a>
    </section>
  );
}

export default App;
